import './styles.css';
import { Game } from './game/Game';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');
if (!canvas) throw new Error('Missing #game-canvas element.');

const begin = document.querySelector<HTMLButtonElement>('#begin')!;
begin.disabled = true;

const game = new Game(canvas);
void game.start();

if (import.meta.hot) {
  import.meta.hot.dispose(() => game.dispose());
}
